<script setup>
import ColorPicker from '@js/components/pickers/ColorPicker.vue';
import { ErrorMessage, Field } from 'vee-validate';

const model = defineModel();

const {
    fieldId,
    fieldName,
    label = null,
    legend = null,
    disabled = false,
    required = false,
    inlineLabel = false,
    size = 'medium',
    presetColors = null,
    withAlpha = false,
    withoutMargin = false,
} = defineProps({
    fieldId: {
        type: String,
        required: true,
    },
    fieldName: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        required: false,
    },
    legend: {
        type: String,
        required: false,
    },
    disabled: {
        type: Boolean,
        required: false,
    },
    required: {
        type: Boolean,
        required: false,
    },
    inlineLabel: {
        type: Boolean,
        required: false,
    },
    size: {
        type: String,
        required: false,
    },
    presetColors: {
        type: Array,
        required: false,
    },
    withAlpha: {
        type: Boolean,
        required: false,
    },
    withoutMargin: {
        type: Boolean,
        required: false,
    },
});
</script>

<template>
    <div
        class="flex"
        :class="{
            'flex-row items-center': inlineLabel,
            'flex-col': !inlineLabel,
            'mb-4': !withoutMargin,
        }"
    >
        <label
            :for="fieldName"
            class="whitespace-nowrap"
            :class="{
                'mr-2': inlineLabel,
                'mb-2': !inlineLabel,
                'text-sm': size === 'small',
            }"
        >
            {{ label }}
            <sup v-if="required" class="text-red-500">*</sup>
        </label>

        <Field :id="fieldId" :name="fieldName" v-model="model">
            <ColorPicker
                v-model="model"
                :disabled="disabled"
                :size="size"
                :preset-colors="presetColors"
                :with-alpha="withAlpha"
            />
        </Field>

        <em v-if="legend" class="mt-1 text-xs text-gray-400">
            {{ legend }}
        </em>

        <ErrorMessage :name="fieldName" class="mt-1 text-sm text-red-500" />
    </div>
</template>
